<label class="box">
	<div class="box__title">{{ title }}</div>
	<p class="box__info">{{ info }}</p>
</label>
